<template>
  <div class="uploader">
    <el-upload v-loading="loading" v-if="!fileFuther.status" class="blue mr20"
      :action="FileUploadURL" :show-file-list="false"  :accept="accept"
      :on-success="handleSuccess"  :before-upload="handlebeforeUpload">
        <el-button  small slot="trigger">上传</el-button>
    </el-upload>
    <div class="mr20 blue" v-if="downFlag && fileFuther.canDownload">
      <el-link  type="primary" :underline="false" :href="fileFuther.downloadUrl" :download="fileFuther.downloadUrl" :title="fileFuther.fileName" :name="fileFuther.fileName" 
        target="_blank">{{downText}}</el-link>
    </div>
    <div class="mr20 blue" v-if="imgItem.fileUrl">
       <el-link v-if="fileUrlLast == 'docx' || fileUrlLast == 'doc' || fileUrlLast == 'xls'|| fileUrlLast == 'xlsx'" type="primary" :underline="false"  target="_blank" :href="imgItem.fileUrl">下载文件</el-link>
      <el-link v-else type="primary" :underline="false" @click='previewLook()'>预览</el-link>
    </div>
    <div class="mr20"  v-else>
      <el-link v-if="orNo" type="primary" :underline="false" >无</el-link>
    </div>
    <div class="mr20 blue ddd" v-if="!fileFuther.status && imgItem.fileUrl">
      <el-link  type="primary" :underline="false" @click='del()'>删除</el-link>
    </div>
    <!-- 企业抵押贷款页面的特殊性。因接口没加字段，所以只能先拎出来写死，以达到功能的实现 -->
    <el-radio-group v-model="radioValue" size="mini" @change='changeRadio($event)' 
        v-if="fileFuther.fileType=='Capital-verification-report'||
        fileFuther.fileType=='audit-report'|| 
        fileFuther.fileType=='accounting-statement'||
        fileFuther.fileType=='bank-statement'||
        fileFuther.fileType=='lease-contract'||
        fileFuther.fileType=='purchase-sale-contract'">
      <el-radio label="无" v-if="!fileFuther.status">无</el-radio>
    </el-radio-group>
    <el-dialog title="预览" :visible.sync="centerDialogVisible" width="65%" center :append-to-body='true'>
      <div style="display:flex; align-items: center; justify-content: center;">
        <el-image :src="imgurl"  style="width:70%;"></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BASE from '@/api/base'
export default {
  props: {
    fileFuther: Object,
    downFlag: {
      default: true,
      type: Boolean
    },
    downText: {
      default: '下载模板',
      type: String
    },
    orNo:false, // 没有url的时候是否显示"无"
  },
  data() {
    return {
      FileUploadURL: this.$common.FileUploadURL,
      loading: false,
      centerDialogVisible: false,
      fileReader: "",
      fileTypeInChild:'', // 文件的格式 pdf 或 img
      imgurl: '', 
      imgItem: {
        fileUrl:''
      },
      radioValue: '', // 企业抵押贷款页面的特殊性: 对于必填项，如果用户没有，让用户单选 '无'
      accept:'image/*,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/*,application/msword,application/vnd.ms-excel'
    }
  },
  watch:{
    imgItem: function(){ // 监听父组件的变化
      this.imgurl = this.imgItem.fileUrl
    }
  },
   computed: {
    fileUrlLast(){
       return this.imgItem.fileUrl.substr(this.imgItem.fileUrl.lastIndexOf(".") * 1 + 1);      
    }
  },
  mounted() {
    this.fileReader = new FileReader();
    if(this.fileFuther.fileList && this.fileFuther.fileList.length)this.imgItem = this.fileFuther.fileList[0]
  },
  methods: {
    del(){
      this.imgItem.fileUrl = ''
    },
    handleSuccess(res, file, fileList) {
      if(res.code === 1000){
        this.$message.success('上传成功')
        this.loading = false
        this.imgurl = res.data
        this.imgItem.fileUrl = res.data
        this.$set(this.fileFuther, 'fileList', []);
        this.fileFuther.fileList[0] = {
          fileName:this.fileFuther.fileName,
          fileUrl:res.data,
          fileType:this.fileFuther.fileType,
          fileTypeType: this.fileFuther.type,
          content: ''  
        }
        this.$forceUpdate();
        this.radioValue = '';
      } else {
        return this.$message.error('上传失败')
      }
    },
    handlebeforeUpload(file) {
      this.loading = true
      // 这里做可以做文件校验操作
      let isImg = false
       if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === "application/pdf" || file.type === 'application/msword' || file.type === 'application/vnd.ms-excel'|| file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type ==='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        isImg = true;
      }
      if (!isImg) {
        this.loading = false
        this.$message.error('上传文件只能是JPG、PNG、PDF、WORD、EXCEL格式 !')
      }
      let isLt5M = file.size / 1024 / 1024 < 50
      if (!isLt5M) {
        this.loading = false
        this.$message.error('上传图片大小不能超过 50MB!')
      }
      return isImg && isLt5M
    },
    previewLook(){
      let filePath = this.imgItem.fileUrl;
      //获取最后一个.的位置
      let index= filePath.lastIndexOf(".");
      //获取后缀
      this.fileTypeInChild = filePath.substr(index+1);
      if(this.fileTypeInChild == 'pdf'){
        window.open(this.imgItem.fileUrl, "_blank");
      }else{
        this.centerDialogVisible=true
      }
      this.$forceUpdate();
    },
    async downloadFile(url,name){
      let path = `${BASE.ZCT_API}/file/download?url=${encodeURI(url)}&name=${encodeURI(name)}`;
      window.location.href = path;
    },
    // 企业抵押贷款页面的特殊性
    changeRadio(val){
      this.imgItem.fileUrl = '';
      this.fileFuther.fileList[0] = {
        fileName: this.fileFuther.fileName,
        fileUrl: this.radioValue,
        fileType: this.fileFuther.fileType,
        fileTypeType: this.fileFuther.type,
        content: this.radioValue,  
      }
      this.$forceUpdate();
    },
     del() {
      this.imgurl = ''
      this.imgItem.fileUrl = ''
      this.$forceUpdate();
    },
  }
}
</script>
<style scoped lang="scss">
.uploader {
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  .blue{
    cursor: pointer;
    color: #007BFF;
    border: 1px solid #007BFF;
    font-size: 10px;
    border-radius: 2px;
    height:30px;
    line-height: 30px;
    width: 70px;
    display: inline-block;
    text-align:center;
    line-height: 1;
    .el-upload{
      .el-button{
        height:30px;
        line-height: 30px;
        width: 70px;
        display: inline-block;
        border: none;
        padding: 0;
        margin: 0;
        color: #007BFF;
      }
    }
    .el-link{
       color: #007BFF;
      height:30px;
      line-height: 30px;
    }
    &:hover {
      background:  none;
    }
  }
}
</style>